<template>
<div class="exitGame">
  <a class="exitGame-link" href="https://www.bnpparibas.pl/misjasamodzielnosc/">< WYJŚCIE Z GRY</a>
</div>
</template>

<script>
export default {
name: "exitGame",
  methods:{
    goBack(){
      window.history.back();
    }
  }
}
</script>


